import React, { useEffect, useState } from 'react';
import BasicTaskListLayout from './layout_01/BasicTaskListLayout';
import axiosInstance from '../../common/utils/interceptor';
import { useBasicDetails } from '../../store/storeApi';
import taskItemStatusMapper from '../../taskList/utils/taskItemStatusMapper';
import { Task } from '../../taskList/interfaces';
import { apiUrls, SessionStore } from '../../constants';
import { filterStageList } from '../utils/basicStageList';
import { getCandidateMessages, CandidateMessages, psuedoResponse } from '../../common/utils/getCandidateMessages';
import { getExperienceInitCookie } from '../../common/utils/experienceInitCookie';
import { getTCPlusFormattedDeadlineDate } from '../../common/utils/dateFormatter';
import { getTaskItemList } from '../utils/getTaskItemsList';
import { FullPageLoader } from '../../common/components';

const BasicTaskListPage = (): JSX.Element => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { updateCurrentWorkflowItem } = useBasicDetails();
  const [tasks = [], setTasks] = useState<Task[]>();
  const [candidateMessages, setCandidateMessages] = useState<CandidateMessages>(psuedoResponse.data);
  const expCookie = getExperienceInitCookie();
  const candidateDeadlineDate = expCookie && expCookie.candidateDeadlineDate;
  const deadlineDate = candidateDeadlineDate && getTCPlusFormattedDeadlineDate(candidateDeadlineDate);

  useEffect(() => {
    const fetchTaskList = async (): Promise<void> => {
      try {
        const res = await axiosInstance.get(apiUrls.GET_BASIC_TASKLIST_DETAILS);
        if (res && res.data && res.data.data) {
          let tasks: Task[] = [];
          const currentWorkflowItems = sessionStorage.getItem(SessionStore.currentWorkflowItem);
          if (currentWorkflowItems) {
            const workflowItem = JSON.parse(currentWorkflowItems);
            const config = JSON.parse(workflowItem.configuration);
            let stageList = res.data.data.productListing;
            if (config?.configWidgetJSON?.tasks) stageList = filterStageList(stageList);
            tasks = taskItemStatusMapper(stageList, workflowItem.nestedItemsState);
            config.configWidgetJSON = { tasks: tasks };
            workflowItem.configuration = JSON.stringify(config);
            sessionStorage.setItem(SessionStore.currentWorkflowItem, JSON.stringify(workflowItem));
            updateCurrentWorkflowItem(workflowItem);
          }
          setTasks(getTaskItemList(tasks));
        }
      } catch (e) {
        console.error('Failed while fetching data !', e);
      }
      setIsLoading(false);
    };
    fetchTaskList();
  }, []);

  useEffect(() => {
    (async (): Promise<void> => {
      const responseData = await getCandidateMessages();
      if (responseData.code === 200) {
        if (responseData.data?.taskListPageContent) setCandidateMessages(responseData.data);
      }
    })();
  }, []);

  if (isLoading) return <FullPageLoader isLoading={isLoading} />;

  return React.createElement(BasicTaskListLayout, { data: tasks, candidateMessages, deadlineDate });
};

export default BasicTaskListPage;
